import { Modal } from "antd";
import styled from "styled-components";
import color from "../_style/color";

export default styled(Modal)`
  /* Antd Modal */
  .ant-modal-header {
    padding: 0 20px !important;
    height: 40px;
    border-color: ${color.gainsboro};
  }
  .ant-modal-content {
    border-radius: 4px;
  }
  .ant-modal-body {
    padding: 20px;
  }
  .ant-modal-footer {
    padding: 0 !important;
    text-align: left;
    display: flex;
  }
  .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
  }
`;
